import GraphLegend from './GraphLegend';

export default GraphLegend;
